export default __webpack_public_path__ + "static/media/statistics-nav.0a659189.svg";